<template>
  <div class="standart-page">
    <b-modal
        id="modal-cancel-confirm"
        centered
        title="Uyarı"
        header-bg-variant="warning"
        header-text-variant="light"
        ok-variant="success"
        ok-title="Tamam"
        cancel-variant="outline-secondary"
        cancel-title="Vazgeç"
        @ok.prevent="$router.go(-1)"
    >
    </b-modal>
    <div class="row mb-3">
      <div class="col-3"></div>
      <div class="col d-flex align-items-center justify-content-center">
        <h3 class="title mb-0">{{$store.state.mb.detail.pageTitle}}</h3>
      </div>
      <div class="col-3 d-flex justify-content-end align-items-center">
        <button class="btn btn-outline-secondary back-button" @click="goBack">
          <font-awesome-icon icon="angle-double-left" class="mr-2"/>
          Listeye Geri Dön
        </button>
      </div>
    </div>
    <div class="row justify-content-center mb-4" v-if="$store.state.mb.recordId != 0">
      <div class="col-5 d-flex justify-content-center">
        <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab===0?'btn-secondary':'btn-outline-secondary'" @click="changeComponent(0,'MBGenelBilgisi')">
            Genel Bilgiler
        </button>
        <Can I="read" a="/meslek-birligi/MBKurulUyesi">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab===1?'btn-secondary':'btn-outline-secondary'" @click="changeComponent(1,'MBKurulBilgisi')">
            Kurul Bilgisi
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBPersonel">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab===2?'btn-secondary':'btn-outline-secondary'" @click="changeComponent(2,'MBPersonel')">
              Birlik Yönetimi/Personeli
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBSistemYoneticisi">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 5 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(5, 'MBSistemYoneticisi')">
            Birlik Sistem Yöneticisi
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBNot">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 3 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(3, 'MBNot')">
            Notlar
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBDokuman">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 4 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(4, 'MBDokuman')">
            Dokümanlar
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBUluslararasiTemsilSozlesmesi">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 6 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(6, 'MBUluslararasiTemsilSozlesmesi')">
            Uluslararası Temsil Sözleşmeleri
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/YMMDokuman">
          <button class="btn btn-block mr-2 mt-0 wsnw" :class="activeTab === 8 ? 'btn-secondary' : 'btn-outline-secondary'" @click="changeComponent(8, 'MBYMMDokuman')">
            Denetleme Kurulu ve YMM Raporları
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBTemelMaliBilgiler">
          <button
            class="btn btn-block mr-2 mt-0 wsnw"
            :class="activeTab === 9 ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="changeComponent(9, 'MBTemelMaliBilgiler')"
          >
            Temel Mali Bilgiler
          </button>
        </Can>
        <Can I="read" a="/meslek-birligi/MBLog2">
          <button
            class="btn btn-block mr-2 mt-0 wsnw"
            :class="activeTab === 7 ? 'btn-secondary' : 'btn-outline-secondary'"
            @click="changeComponent(7, 'MBLog')"
          >
            Loglar
          </button>
        </Can>
      </div>
    </div>
    <component :is="$store.state.mb.detail.currentTab"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
  },
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    ...mapActions('mb', ['changeDetailTab']),
    changeComponent(id, cmp) {
      this.activeTab = id;
      this.changeDetailTab(cmp);
    },
    goBack() {
      if (this.isChanged) {
        this.$bvModal.show('modal-cancel-confirm');
      } else {
        this.$router.go(-1);
      }
    }
  },
  created() {
    this.changeComponent(0, 'MBGenelBilgisi');
    this.$store.state.mb.recordId = 0;
  },
  computed: {
    ...mapGetters('general', ['getMessage'])
  },
  watch: {
    
  }
}
</script>